$w.onReady(function () {
    wixWindow.openLightbox("Join the T4L Blog Family!");
});
